"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectType = void 0;
var ObjectType;
(function (ObjectType) {
    ObjectType["Product"] = "product";
    ObjectType["Page"] = "page";
    ObjectType["QuerySuggestions"] = "query_suggestions";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
//# sourceMappingURL=objectType.js.map